const experiences = [
  {
    id: 1,
    title: 'Discovery Flight',
    duration: '15-20 minutes',
    description: 'Perfect for first-timers. Experience the thrill of paragliding with a gentle introduction to flying.',
    features: ['Safety briefing', 'Basic maneuvers', 'Scenic views', 'Photos included'],
    image: 'https://public.readdy.ai/ai/img_res/e2e8646d97aececea3c8c17047db60e9.jpg',
    popular: false
  },
  {
    id: 2,
    title: 'Thermal Flight',
    duration: '30-45 minutes',
    description: 'Extended flight using thermal currents to gain altitude and enjoy breathtaking panoramic views.',
    features: ['Extended flight time', 'Thermal soaring', 'Aerial photography', 'Video recording', 'Certificate'],
    image: 'https://readdy.ai/api/search-image?query=Paraglider%20soaring%20high%20using%20thermal%20currents%2C%20dramatic%20mountain%20peaks%20below%2C%20expansive%20aerial%20view%2C%20professional%20tandem%20flight%2C%20vibrant%20paraglider%20colors%20against%20blue%20sky%2C%20adventure%20sports%20action%20shot%2C%20clean%20mountain%20background&width=600&height=400&seq=thermal-flight-exp&orientation=landscape',
    popular: true
  },
  {
    id: 3,
    title: 'Acrobatic Flight',
    duration: '20-30 minutes',
    description: 'For thrill-seekers! Experience exciting maneuvers including spirals, wingovers, and more.',
    features: ['Adrenaline maneuvers', 'Spirals & wingovers', 'GoPro footage', 'For experienced flyers', 'Maximum thrills'],
    image: 'https://readdy.ai/api/search-image?query=Acrobatic%20paragliding%20maneuver%20in%20action%2C%20dynamic%20spiral%20flight%2C%20extreme%20sports%20photography%2C%20paraglider%20performing%20wingover%20against%20clear%20sky%2C%20adrenaline%20adventure%2C%20dramatic%20angle%2C%20simple%20background%20highlighting%20the%20action&width=600&height=400&seq=acrobatic-flight-exp&orientation=landscape',
    popular: false
  },
  {
    id: 4,
    title: 'Sunset Flight',
    duration: '25-35 minutes',
    description: 'Magical experience flying during golden hour with stunning sunset views over the landscape.',
    features: ['Golden hour flight', 'Romantic experience', 'Spectacular colors', 'Professional photos', 'Champagne toast'],
    image: 'https://readdy.ai/api/search-image?query=Paragliding%20at%20sunset%20with%20golden%20orange%20sky%2C%20romantic%20tandem%20flight%20during%20golden%20hour%2C%20silhouette%20of%20paraglider%20against%20colorful%20sunset%20clouds%2C%20peaceful%20evening%20flight%2C%20warm%20lighting%2C%20simple%20clean%20horizon%20background&width=600&height=400&seq=sunset-flight-exp&orientation=landscape',
    popular: false
  }
];

export default function Experiences() {
  return (
    <section id="experiences" className="py-24 bg-gradient-to-b from-white to-sky-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Choose Your Adventure
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Select the perfect flight experience tailored to your comfort level and sense of adventure
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {experiences.map((exp) => (
            <div 
              key={exp.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2 relative"
            >
              {exp.popular && (
                <div className="absolute top-4 right-4 bg-sky-600 text-white px-4 py-1 rounded-full text-sm font-semibold z-10">
                  Most Popular
                </div>
              )}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={exp.image}
                  alt={exp.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{exp.title}</h3>
                <div className="flex items-center mb-4">
                  <span className="text-sky-600 font-semibold flex items-center">
                    <i className="ri-time-line mr-2"></i>
                    {exp.duration}
                  </span>
                </div>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {exp.description}
                </p>
                <ul className="space-y-2 mb-6">
                  {exp.features.map((feature, index) => (
                    <li key={index} className="flex items-start text-sm text-gray-700">
                      <i className="ri-check-line text-sky-600 mr-2 mt-0.5 flex-shrink-0"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <button 
                  onClick={() => {
                    const element = document.getElementById('booking');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full bg-sky-600 text-white py-3 rounded-full font-semibold hover:bg-sky-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Book This Flight
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}